const selector = {
    addTag: '.js_action_add_tag',
    addMlffTag: '.js_action_add_mlff_tag',
    btnLostTag: '.js_btn_lost_tag',
    btnFoundTag: '.js_btn_found_tag',
    btnActivateTag: '.js_btn_activate_tag',
    btnDeactivateTag: '.js_btn_deactivate_tag',
    btnEditNickname: '.js_btn_edit_nickname',
    nicknameModalSaveButton: '#customer_modal_edit_nickname .js_btn_modal_save',
    hr: {
        tagType: 'input[name="hr_tag_type"]',
        tagTypeGeaRadio: 'input[name="hr_tag_type"][value="02"]',
        tagTypeQFreeRadio: 'input[name="hr_tag_type"][value="06"]',
        tagTypeGeaContainer: '#hr_gea_container',
        tagTypeQFreeContainer: '#hr_qfree_container',
    },
    modal: {
        add: '#customer_modal_add_tag',
        addMlff: '#customer_modal_add_mlff_tag',
        lostTag: '#customer_modal_lost_tag',
        foundTag: '#customer_modal_found_lost_tag',
        activateTag: '#customer_modal_activate_tag',
        deactivateTag: '#customer_modal_deactivate_tag'
    },
    inputTagId: '#tag_id',
    country: '#userCountry',
    addTagLoader: '#add_tag_loader',
    editNicknameInput: '#tag_nickname_input'
};

export { selector };
